<template>
  <div class="team_members">
     <div class="team_members_content" v-if="memberList.length > 0">
         <div class="team_members_top" ref="wrapper">
            <div class="team_members_top_information">
                  <div class="team_members_top_information_block" 
                  :class="current == index ? 'is_active' : ''" 
                  v-for="(item,index) in memberList" :key="item.id"
                  @click="onClick(index,item.id)">
                     <div class="team_members_top_information_block_left">
                        <img :src="item.headImg">
                        <p class="team_members_top_information_block_left_gender" :class="item.sex == 1 ? 'boy' : 'girl'"></p>
                     </div>
                     <div class="team_members_top_information_block_right">
                        <p class="team_members_top_information_block_right_nickName">{{item.studentName}}</p>
                        <p class="team_members_top_information_block_right_figure">
                           <span class="team_members_top_information_block_right_figure_sex">{{item.sex == 1 ? '男' : '女'}}</span>
                           <span class="team_members_top_information_block_right_figure_age">{{item.age}}岁</span>
                        </p>
                     </div>
                  </div>

            </div>
         </div>
         <div class="team_members_bottom">
            <!-- 默认标签 -->
            <div class="team_members_bottom_tag default">
                  <span class="team_members_bottom_tag_item" v-for="(val,index) in labelList" :key='val+index'>{{val}}</span>
            </div>
            <!-- 自定义标签 -->
            <div class="team_members_bottom_tag custom">
               <span class="team_members_bottom_tag_item" v-for="(val,index) in customTagList" :key='val+index'>{{val}}</span>
            </div>
         </div>
         
     </div>
     <div class="team_members_noData" v-if="memberList.length == 0">
         <span>{{cueMsg}}</span>
      </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
   name:"team-members",
   props:{
      componentData:{
         type:Object
      },
   },
   components:{},
   data() {
      return {
         current:0, // 当前小组成员
         memberList:[], // 小组成员列表
         customTagList:[], // 自定义标签列表
         cueMsg:'您还没有分组哦。',
      }
   },
   watch:{
      componentData:{
         handler(data) {
            this.memberList = JSON.parse(JSON.stringify(data.groupList)) || []
            if(this.memberList.length > 0){
               let labelObj = this.memberList[this.current].psyStudentFavoriteLabelVO
               this.customTagList = (labelObj && JSON.parse(JSON.stringify(labelObj)) != "{}") ? labelObj.customLabelList : [];
               this.labelList = (labelObj && JSON.parse(JSON.stringify(labelObj)) != "{}") ? labelObj.labelList : [];
            }
            if(this.bs){
               setTimeout(()=>{
                  this.initSroll()
               },200)
            }
            
         },
         immediate:true,
         deep:true,
         bs:null,
      },
   },
   created() {

   },
   mounted() {
      // 儿童列表滚动效果
      this.$nextTick(()=>{
         setTimeout(()=>{
            this.initSroll()
         },200)
      })
   },
   methods:{
      initSroll() {
         if(!this.$refs.wrapper){
            return;
         }
        this.bs = new BScroll(this.$refs.wrapper,{
            pullUpLoad: true, // 不触发上拉事件
            pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:true,
            scrollY:false, // 关闭纵向滚动功能
            bounce:false, // 关闭滚动到边缘时的回弹动作
            click:true, // 开启点击事件
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
         })
      },
      onClick(index,id) {
         this.current = index;
         let labelObj = this.memberList[this.current].psyStudentFavoriteLabelVO
         this.customTagList = (labelObj && JSON.parse(JSON.stringify(labelObj)) != "{}") ? labelObj.customLabelList : [];
         this.labelList = (labelObj && JSON.parse(JSON.stringify(labelObj)) != "{}") ? labelObj.labelList : [];
         // 查询某个儿童下的标签
      },
   }
}
</script>

<style lang="scss" scoped>
.team_members{
   width:100%;
   height:100%;
   .team_members_content{
      width:100%;
      height:100%;
      overflow-x:auto;
      padding:66px 62px 37px 68px;
   }
   .team_members_top{
      width:100%;
       overflow:hidden;
       position: relative;
      .team_members_top_information{
       
         white-space: nowrap;
         overflow-x:scroll;
         display: inline-block;
         .team_members_top_information_block{
            display:inline-block;
            min-width:128px;
            
            min-height:68px;
            
            padding: 14px 23px 14px 17px;
            background: url('../../assets/images/children-file/block.png') no-repeat;
            background-size:100% 100%;
            vertical-align: top;
            &:not(:last-child){
               margin-right:12px;
            }
            &.is_active{
               background: url('../../assets/images/children-file/block-active.png') no-repeat;
               background-size:100% 100%;
            }
            .team_members_top_information_block_left{
               position:relative;
               margin-right:8px;
               height:40px;
               display: inline-block;
               vertical-align: top;
               // top:14px;
               // left:17px;
               img{
                  width:40px;
                  height:40px;
                  border-radius: 25px;
               }
               .team_members_top_information_block_left_gender{
                  width:14px;
                  height:14px;
                  position: absolute;
                  left:29px;
                  top:29px;
                  &.girl{
                     background:url('../../assets/images/children-file/female.png') no-repeat;
                     background-size:cover;
                  }
                  &.boy{
                     background:url('../../assets/images/children-file/male.png') no-repeat;
                     background-size:cover;
                  }
               }
            }
            .team_members_top_information_block_right{
                display: inline-block;
               font-size:12px;
               height:36px;
               color:#fff;
               font-family: PingFangSC-Regular, PingFang SC;
               font-weight:400;
               .team_members_top_information_block_right_nickName{
                  height:17px;
                  line-height:17px;
                  margin-bottom:4px;
               }
               .team_members_top_information_block_right{
                  line-height:17px;
               }
               .team_members_top_information_block_right_figure_sex{
                  margin-right:6px;
               }

            }
         }
      }
   }
   .team_members_bottom{
      margin-top:26px;
      // padding:0 72px;
      .team_members_bottom_tag{
         .team_members_bottom_tag_item{
            display: inline-block;
            padding:4px 14px;
            border-radius:6px;
            font-size:12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight:400;
            line-height:17px;
            margin-bottom:20px;
            &:not(:last-child){
               margin-right:12px;
            }
            &:nth-child(5n+1){
               color:#F56444;
               background:rgba(255,148,134,0.1);
            }
            &:nth-child(5n+2){
               color:#FF8340;
               background:rgba(255,131,64,0.1);
            }
            &:nth-child(5n+3){
               color:#49CC9A;
               background:rgba(73,204,154,0.1);
            }
            &:nth-child(5n+4){
               color:#25A6F9;
               background:rgba(37,166,249,0.1);
            }
            &:nth-child(5n+5){
               color:#887DF7;
               background:rgba(157,154,299,0.1);
            }
         }
      }
   }
   .team_members_noData{
      width:100%;
      height:100%;
      color:#666;
      font-size:16px;
      font-weight:400;
      font-family:PingFangSC-Regular, PingFang SC;
      line-height:1;
      display: flex;
      justify-content: center;
      align-items: center;
   }
}
</style>